import React, { useEffect, useRef, useState } from 'react'
import { motion } from 'framer-motion'
import x from '../../assets/icons/close.svg'
import photo from '../../assets/icons/phot.svg'
import editPackage from '../../apis/editPackage'

const EditPackage = ({ close, pack, updatePackage }) => {
  console.log(pack)
  const popupref = useRef(null)
  const [error, setError] = useState('')
  const [packageData, setPackageData] = useState({
    ...pack,
    discountClient: pack.client_offers ? true : false,
    discountPos: pack.pos_offers ? true : false,
  })

  const [imageFile, setImageFile] = useState(null)
  const [preview, setPreview] = useState(pack.image || null)
  const [loading, setLoading] = useState(false)

  const handleEditPackage = async (e) => {
    e.preventDefault()

    if (!pack.image && !imageFile) {
      setError('add an image')
      return
    }
    let edited = false
    const formData = new FormData()
    if (isNaN(packageData.count)) {
      setError('quantity should be a number')
      return
    }
    if (isNaN(packageData.max_number_to_buy_at_once)) {
      setError('max number to buy should be a number')
      return
    }

    if (
      (packageData.price_client && isNaN(packageData.price_client)) ||
      (packageData.price_client_offers &&
        isNaN(packageData.price_client_offers)) ||
      (packageData.price_pos_offers && isNaN(packageData.price_pos_offers)) ||
      (packageData.price_pos_client && isNaN(packageData.price_pos_client))
    ) {
      setError('price should be a number')
      return
    }

    // Check each field and append to formData only if it has changed
    if (pack.title !== packageData.title) {
      formData.append('title', packageData.title)
      edited = true
    }
    if (pack.count !== packageData.count) {
      formData.append('count', packageData.count)
      edited = true
    }
    if (pack.is_active !== packageData.is_active) {
      formData.append('is_active', packageData.is_active)
      edited = true
    }
    if (pack.out_of_stock !== packageData.out_of_stock) {
      formData.append('out_of_stock', packageData.out_of_stock)
      edited = true
    }
    if (pack.serial_number !== packageData.serial_number) {
      formData.append('serial_number', packageData.serial_number)
      edited = true
    }
    if (
      pack.max_number_to_buy_at_once !== packageData.max_number_to_buy_at_once
    ) {
      formData.append(
        'max_number_to_buy_at_once',
        packageData.max_number_to_buy_at_once
      )
      edited = true
    }

    // Price Client
    if (pack.price_client !== packageData.price_client) {
      formData.append('price_client', packageData.price_client)
      edited = true
    }
    if (packageData.discountClient) {
      if (packageData.price_client_offers > packageData.price_client) {
        setError('the descount should be less than the price')
        return
      }
      formData.append('price_client_offers', packageData.price_client_offers)
      edited = true
    }

    // Price Pos Client
    if (pack.price_pos_client !== packageData.price_pos_client) {
      formData.append('price_pos_client', packageData.price_pos_client)
      edited = true
    }
    if (packageData.discountPos) {
      if (packageData.price_pos_offers > packageData.price_pos_client) {
        setError('the descount should be less than the price')
        return
      }
      formData.append('pos_offers', packageData.price_pos_offers)
      edited = true
    }

    // Append image if updated
    if (imageFile) {
      formData.append('image', imageFile)
      edited = true
    }

    // Only call the API if changes are detected
    if (edited) {
      try {
        setLoading(true)
        await editPackage(pack.id, formData)

        // Update the local state
        updatePackage({
          ...pack,
          ...packageData,
          pos_offers: packageData.discountPos ? packageData.pos_offers : null,
          client_offers: packageData.discountClient
            ? packageData.client_offers
            : null,
          image: imageFile ? URL.createObjectURL(imageFile) : pack.image,
        })

        close()
      } catch (error) {
        console.error('Error updating package:', error)
        setError(error.response?.data?.message || 'Failed to update package')
      } finally {
        setLoading(false)
      }
    } else {
      console.log('No changes detected')
    }
  }
  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target

    setPackageData((prevData) => {
      const updatedData = {
        ...prevData,
        [name]: type === 'checkbox' ? (checked ? 1 : 0) : value,
      }

      // Synchronize discount price with normal price if the discount checkbox is unchecked
      if (name === 'discountClient' && !checked) {
        updatedData.client_offers = updatedData.price_client
      }
      if (name === 'discountPos' && !checked) {
        updatedData.pos_offers = updatedData.price_pos_client
      }

      return updatedData
    })

    setError('')
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0]
    setImageFile(file)
    setPreview(URL.createObjectURL(file))
    setError('')
  }
  const handleDragOver = (e) => {
    e.preventDefault()
  }

  const handleDrop = (e) => {
    e.preventDefault()
    const file = e.dataTransfer.files[0]
    setImageFile(file)
    setPreview(URL.createObjectURL(file))
  }
  const clearFiles = (e) => {
    e.preventDefault()
    setPreview(null)
    setImageFile(null)
  }

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (popupref.current && !popupref.current.contains(event.target)) close()
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => document.removeEventListener('mousedown', handleClickOutside)
  }, [popupref, close])

  return (
    <motion.div
      className="fixed inset-0 bg-overlay/30 w-screen z-40 h-screen grid place-items-center"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <motion.div
        ref={popupref}
        initial={{ opacity: 0, y: -100 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: 100 }}
        transition={{ duration: 0.3 }}
        className="w-1/2 min-h-10 overflow-hidden bg-white rounded-lg flex flex-col justify-center items-center"
      >
        <form onSubmit={handleEditPackage} className="w-full">
          <div className="w-full px-8 py-5 flex flex-col gap-8">
            <div className="flex border-b pb-4 justify-between w-full">
              <div>Edit Package</div>
              <img src={x} onClick={close} className="cursor-pointer" alt="" />
            </div>
            <div className="flex gap-4 justify-center items-stretch">
              {/* Left Section */}
              <div className="w-1/2 flex flex-col gap-4">
                <div className="rounded-xl p-4 border border-b-darkBlue">
                  <label
                    htmlFor="image"
                    className="cursor-pointer relative"
                    onDragOver={handleDragOver}
                    onDrop={handleDrop}
                  >
                    <input
                      id="image"
                      type="file"
                      accept="image/*"
                      onChange={handleFileChange}
                      className="hidden"
                    />
                    {preview ? (
                      <div className="absolute top-2 right-2 z-10">
                        <img
                          onClick={clearFiles}
                          src={x}
                          alt="Clear"
                          className="cursor-pointer"
                        />
                      </div>
                    ) : (
                      <div className="flex justify-center items-center">
                        Choose or Drop a File
                      </div>
                    )}
                    <img
                      src={preview || photo}
                      alt="Preview"
                      className="w-full h-28 object-contain"
                    />
                  </label>
                </div>
                <div>
                  <label>Package Title</label>
                  <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                    <input
                      name="title"
                      placeholder="Package Title"
                      value={packageData.title}
                      onChange={handleInputChange}
                      className="w-full focus:outline-none"
                      required
                    />
                  </div>
                </div>
                <div>
                  <label>Package quantity</label>
                  <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                    <input
                      name="count"
                      placeholder="Quantity"
                      value={packageData.count}
                      onChange={handleInputChange}
                      className="w-full focus:outline-none"
                      required
                    />
                  </div>
                </div>

                <div>
                  <label>Max Number To Buy At Once</label>
                  <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                    <input
                      name="max_number_to_buy_at_once"
                      placeholder="Max Number To Buy At Once"
                      value={packageData.max_number_to_buy_at_once}
                      onChange={handleInputChange}
                      className="w-full focus:outline-none"
                      required
                    />
                  </div>
                </div>
              </div>

              {/* Right Section */}
              <div className="w-1/2 flex flex-col gap-4">
                <div>
                  <label>Serial Number</label>
                  <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                    <input
                      name="serial_number"
                      placeholder="Serial Number"
                      value={packageData.serial_number}
                      onChange={handleInputChange}
                      className="w-full focus:outline-none"
                      required
                    />
                  </div>
                </div>

                <div>
                  <div>
                    <label>Price for Normal User</label>
                    <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                      <input
                        name="price_client"
                        placeholder="Price"
                        value={packageData.price_client}
                        onChange={handleInputChange}
                        className="w-full focus:outline-none"
                      />
                    </div>
                  </div>
                  <label>
                    <input
                      type="checkbox"
                      name="discountClient"
                      checked={packageData.discountClient}
                      onChange={handleInputChange}
                      className="mr-2"
                    />
                    Add Discount?
                  </label>
                  {packageData.discountClient && (
                    <div>
                      <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                        <input
                          name="price_client_offers"
                          placeholder="Discounted Price"
                          value={packageData.price_client_offers}
                          onChange={handleInputChange}
                          className="w-full focus:outline-none"
                        />
                      </div>
                    </div>
                  )}
                </div>

                <div>
                  <div>
                    <label>Price for Wholesaler</label>
                    <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                      <input
                        name="price_pos_client"
                        placeholder="Price"
                        value={packageData.price_pos_client}
                        onChange={handleInputChange}
                        className="w-full focus:outline-none"
                      />
                    </div>
                  </div>
                  <label>
                    <input
                      type="checkbox"
                      name="discountPos"
                      checked={packageData.discountPos}
                      onChange={handleInputChange}
                      className="mr-2"
                    />
                    Add Discount?
                  </label>
                  {packageData.discountPos && (
                    <div>
                      <div className="w-full rounded-xl px-4 py-3 border-[1px] border-b-darkBlue">
                        <input
                          name="price_pos_offers"
                          placeholder="Discounted Price"
                          value={packageData.price_pos_offers}
                          onChange={handleInputChange}
                          className="w-full focus:outline-none"
                        />
                      </div>
                    </div>
                  )}

                  <div className=" flex justify-between items-center w-full">
                    <label>
                      <input
                        type="checkbox"
                        name="out_of_stock"
                        checked={packageData.out_of_stock === 1 ? true : false}
                        onChange={handleInputChange}
                        className="mr-2"
                      />
                      Out Of Stock
                    </label>
                    <label>
                      <input
                        type="checkbox"
                        name="is_active"
                        checked={packageData.is_active === 1 ? true : false}
                        onChange={handleInputChange}
                        className="mr-2"
                      />
                      Active
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {error && (
            <div className=" w-full flex justify-center py-3 items-center">
              <span className=" bg-red/20 px-3 py-1 text-red rounded">
                {error}
              </span>
            </div>
          )}
          <button
            disabled={loading}
            className="disabled:bg-blueButton/50 bg-blueButton text-white p-4 w-full rounded"
          >
            {loading ? 'Updating...' : 'Update'}
          </button>
        </form>
      </motion.div>
    </motion.div>
  )
}

export default EditPackage
